import { ArrowLeft, ArrowRight } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import BadgeCmp from 'src/components/BadgeCmp';
import TooltipCmp from 'src/components/TooltipCmp';
import { onError } from 'src/utils/CommonFunctions';

interface TabButtonProps {
    tabArray: any;
    isTooltip?: any;
    isActive: any;
    handleOnClick?: any;
    className?: any;
    activeClassName?: any;
    parentClassName?: any;
    tabTextClass?: any;
    tabParentClassName?: any;
    isTab?: any;
    isVerticalBoxTab?: boolean;
    isTabBadgeStylePill?: boolean;
    tabBadgeClassName?: any;
    isScrollable?: boolean;
    leftSideContent?: any;
    leftSideContentActiveClass?: string;
    leftSideContentClass?: string;
    isOnlyIcon?: boolean;
    disabledClassName?: string;
    isModalTabVerticalSidebar?: boolean;
    tabSize?: 'sm';
    isActiveSubTab?: any;
    handleSubTabClick?: any;
}

const TabButton = ({
    tabArray,
    isTooltip,
    isActive,
    handleOnClick,
    className,
    activeClassName,
    parentClassName,
    tabTextClass,
    tabParentClassName,
    isTab,
    isVerticalBoxTab,
    isTabBadgeStylePill,
    tabBadgeClassName,
    isScrollable = false,
    leftSideContent,
    leftSideContentActiveClass,
    leftSideContentClass,
    isOnlyIcon,
    disabledClassName = '',
    isModalTabVerticalSidebar,
    tabSize,
    isActiveSubTab,
    handleSubTabClick,
}: TabButtonProps) => (
    <div className={`flex items-center ${tabParentClassName} ${isModalTabVerticalSidebar && 'w-[225px] bg-utilityGray300 p-3 border-r border-utilityGray200 !items-start'}`}>
        {isScrollable && <ArrowLeft className="text-gray400 w-4 h-4 flex-none mb-0.5 mr-2 cursor-pointer" />}

        <div
            className={`flex ${tabSize === 'sm' ? 'rounded-md' : 'rounded-lg'} w-fit  custom-scrollbar ${
                isTooltip ? '[&>div>div]:border-r-0 [&>div:last-child>div]:rounded-r-lg [&>div:last-child>div]:border-r [&>div:first-child>div]:rounded-l-lg' : 'overflow-auto scrollbar-hide '
            } ${isTab ? 'rounded-[10px] border border-utilityGray200 bg-gray50 p-[3px] shadow-sm gap-1' : isVerticalBoxTab ? 'tab-box-vertical-parent' : 'shadow-sm'} ${
                isTab && isTooltip ? '[&>div:last-child>div]:border-r-0' : ''
            } ${parentClassName} `}
        >
            {tabArray.map((tab: any, index: number) =>
                isTooltip ? (
                    <TooltipCmp
                        key={index}
                        message={tab.tooltipValue}
                        childrenClassName={`${className} ${
                            isTab ? 'rounded-md px-3 py-0.5 flex items-center justify-center gap-x-2 min-h-[24px]' : 'min-h-[32px] flex justify-center items-center border border-borderPrimary !block'
                        } cursor-pointer text-xs font-semibold text-center ${
                            isActive === tab.value ? activeClassName ?? 'bg-white shadow-sm text-textSecondary' : isTab ? 'text-gray500' : 'bg-white text-textSecondary '
                        } ${tab.disabled ? `opacity-50 pointer-events-none ${disabledClassName || ''}` : ''}`}
                    >
                        <div
                            data-value={tab.value}
                            data-disabled={tab.disabled ? 'true' : 'false'}
                            onClick={handleOnClick}
                            data-test-id={tab.name}
                            className={`flex items-center justify-center ${isTab ? '' : 'xl:px-4 lg:px-4 sm:px-3 px-2 h-[30px]'}`}
                        >
                            {tab.image && <img data-value={tab.value} className="rounded border border-utilityGray200 w-5 h-5 flex-none" onError={onError} src={tab.image} />}

                            {tab.icon && (
                                <span data-value={tab.value} className="pointer-events-none">
                                    {tab.icon}
                                </span>
                            )}
                            <span data-value={tab.value} className={`${tabTextClass} truncate`}>
                                {tab.name}
                            </span>
                        </div>
                    </TooltipCmp>
                ) : (
                    <React.Fragment key={index}>
                        <div
                            className={`cursor-pointer text-xs  ${className} ${
                                isTab
                                    ? `${tabSize === 'sm' ? 'min-h-[20px] rounded' : 'min-h-[24px] rounded-md '} ${
                                          tabSize === 'sm' && isOnlyIcon ? '!p-0.5' : 'px-3 py-0.5 '
                                      } flex items-center justify-center gap-x-2 text-center font-semibold  `
                                    : isVerticalBoxTab
                                    ? 'tab-box-vertical'
                                    : `${
                                          tabSize === 'sm' ? 'min-h-[28px] ' : 'min-h-[32px] '
                                      } flex justify-center items-center gap-x-2  lg:py-1 py-2 xl:px-4 lg:px-4 sm:px-3 px-2  border border-borderPrimary border-r-0 last:rounded-r-lg last:border-r first:rounded-l-lg text-center font-semibold   `
                            } ${
                                isActive === tab.value && !(isModalTabVerticalSidebar && isActiveSubTab && tab.subTabs?.some((st: any) => st.value === isActiveSubTab))
                                    ? activeClassName ?? 'bg-white shadow-md text-textSecondary font-semibold'
                                    : isTab
                                    ? 'text-gray500 font-semibold'
                                    : isVerticalBoxTab
                                    ? ''
                                    : 'bg-white text-textSecondary font-semibold'
                            } ${isOnlyIcon && tabSize !== 'sm' && '!px-1.5'} ${tab.disabled ? disabledClassName : ''}`}
                            data-value={tab.value}
                            data-disabled={tab.disabled ? 'true' : 'false'}
                            onClick={handleOnClick}
                            data-test-id={tab.name}
                        >
                            {tab.image && <img data-value={tab.value} className="rounded border border-utilityGray200 w-5 h-5 flex-none" onError={onError} src={tab.image} />}
                            {leftSideContent && <div className={`${isActive === tab.value ? `${leftSideContentActiveClass}` : ``} ${leftSideContentClass}`}>{leftSideContent}</div>}
                            {tab.icon && (
                                <span data-value={tab.value} className="pointer-events-none">
                                    {tab.icon}
                                </span>
                            )}
                            <span data-value={tab.value} className={`${isOnlyIcon && 'hidden'} ${tabTextClass}`}>
                                {tab.name}
                            </span>
                            {(tab?.count && tab?.count > 0) || tab?.isAlwaysCountShow ? (
                                <BadgeCmp
                                    style={`${isTabBadgeStylePill ? 'pill' : 'modern'}`}
                                    type={isActive === tab.value ? 'primary' : 'gray'}
                                    mainClassName={`${isTabBadgeStylePill ? '!border-utilityGray200' : 'bg-white'} ${
                                        tabSize === 'sm' ? '!py-0 !px-1 !rounded' : ''
                                    } min-w-5 justify-center ${tabBadgeClassName} ${tab?.showDotAboveCount ? 'relative' : ''}`}
                                    isHidePillDot
                                    dataValue={tab.value}
                                >
                                    {tab?.count ?? 0}
                                    {tab?.showDotAboveCount && <div className="absolute -top-[3px] -right-[3px] w-2 h-2 bg-danger600 rounded-full"></div>}
                                </BadgeCmp>
                            ) : (
                                ''
                            )}
                        </div>

                        {/* Sub-tabs: only in vertical sidebar mode, only under the active parent tab */}
                        {isModalTabVerticalSidebar && isActive === tab.value && tab.subTabs && tab.subTabs.length > 0 && (
                            <div className="flex flex-col gap-0.5">
                                {tab.subTabs.map((subTab: any, subIndex: number) => (
                                    <div
                                        key={subIndex}
                                        data-value={subTab.value}
                                        data-parent-value={tab.value}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleSubTabClick?.(e);
                                        }}
                                        className={`tab-box-vertical pl-[26px] py-1 cursor-pointer font-normal ${
                                            isActiveSubTab === subTab.value ? 'tab-box-vertical-active' : '!text-grayLight600 hover:!bg-gray50 hover:!text-grayLight700'
                                        }`}
                                    >
                                        {subTab.icon && (
                                            <span data-value={subTab.value} className="pointer-events-none">
                                                {subTab.icon}
                                            </span>
                                        )}
                                        <span data-value={subTab.value} className={tabTextClass}>
                                            {subTab.name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </React.Fragment>
                )
            )}
        </div>
        {isScrollable && <ArrowRight className="text-gray400 w-4 h-4 flex-none mb-0.5 ml-2 cursor-pointer" />}
    </div>
);

export default TabButton;
